import React from 'react';
import { pluralize, thousandsSeparator } from 'utils';
import { RailsPaging } from '~/typings/services/rails/paging';

interface Props {
  paging: RailsPaging;
}

const ResultCount: React.FC<Props> = ({ paging }) => (
  <div className="text-slate-green-500 text-sm">
    {thousandsSeparator(paging.total_count)}
    {paging.total_count_truncated && '+'}{' '}
    {pluralize(paging.total_count, 'Result', 'Results')}
  </div>
);

export default ResultCount;
